import { useInject } from '@vk-hr-tek/core/ioc';
import { ValidationService } from '@vk-hr-tek/core/validation';
import { Box } from '@vk-hr-tek/ui/Box';
import { FormError, TextInput, Form } from '@vk-hr-tek/app-ui/form';
import { Link } from '@vk-hr-tek/ui/Link';
import { Icon } from '@vk-hr-tek/ui/Icon';

import { useDispatch, useSelector } from '@app/hooks';

import { SendInviteDto } from '../../../dto';
import { useTarget, useGetAuthInstance } from '../../../hooks';
import {
  selectNotification,
  selectStatus,
  sendInvite,
  redirectToLogin,
} from '../../../slice';
import { Button } from '../../../segments';

export const SendInviteInit = () => {
  const dispatch = useDispatch();
  const validator = useInject(ValidationService);
  const [target] = useTarget();

  const error = useSelector(selectNotification);
  const status = useSelector(selectStatus);
  const authInstance = useGetAuthInstance();

  const { button_color: buttonColor } = authInstance;

  const onSubmit = (values: SendInviteDto) =>
    new Promise((resolve) => {
      dispatch(
        sendInvite({
          values: {
            ...values,
            target,
          },
          actions: { resolve },
        }),
      );
    });

  return (
    <Form
      validate={(values) => validator.validate(values, SendInviteDto, ['form'])}
      onSubmit={onSubmit}
      render={({
        handleSubmit,
        submitting,
        pristine,
        hasValidationErrors,
        dirtySinceLastSubmit,
      }) => (
        <form onSubmit={handleSubmit}>
          <TextInput
            name="snils"
            label="СНИЛС"
            placeholder="Введите свой СНИЛС"
            mask="999-999-999 99"
            id="qaAuthInviteInitSnilsInput"
            testId="test-id-snils-input"
          />
          <TextInput
            name="password"
            type="password"
            label="Пароль"
            placeholder="Введите ваш пароль"
            id="qaAuthInviteInitPassInput"
            testId="test-id-password-input"
          />
          {!dirtySinceLastSubmit && status && status === 'failed' && (
            <FormError error={error} />
          )}
          <Box mt="32">
            <Button
              color={buttonColor && `#${buttonColor}`}
              disabled={pristine || hasValidationErrors}
              loading={submitting}
              testId="test-id-submit-invite-button"
            >
              Продолжить
            </Button>
          </Box>
          <Box mt="8">
            <Link
              onClick={() => {
                dispatch(redirectToLogin());
              }}
              size="small"
              variant="tertiary"
              startIcon={<Icon name="chevron_left" size="16" />}
            >
              Вернуться назад
            </Link>
          </Box>
        </form>
      )}
    />
  );
};
